/* ================= KONNI39 - DOC FILE EXCEL SAN =================
   Nhan dien kenh, ban do cot, doc tung dong.
   Tach nguyen ven tu app/KONNI39-xu-ly-don-hang_v4.html.
   Quy tac chi tiet: docs/01-DU-LIEU.md muc 1 va 2.
   Chi phu thuoc XLSX (SheetJS) — truyen vao tu ngoai de dung chung
   cho browser (CDN/npm) va node (test).
================================================================= */
import { norm, normKey, toInt, dateText } from './text.js';
import { displayName } from './rules.js';

/* ---------- tu dien cot ---------- */
export const FIELDS = {
  SHOPEE: {
    orderId: ['mã đơn hàng'],
    tracking: ['mã vận đơn'],
    carrier: ['đơn vị vận chuyển'],
    status: ['trạng thái đơn hàng'],
    returnStatus: ['trạng thái trả hàng/hoàn tiền'],
    sku: ['sku sản phẩm'],
    skuVariation: ['sku phân loại hàng'],
    name: ['tên sản phẩm'],
    variation: ['tên phân loại hàng'],
    qty: ['số lượng'],
    orderDate: ['ngày đặt hàng']
  },
  TIKTOK: {
    orderId: ['order id'],
    tracking: ['tracking id'],
    carrier: ['shipping provider name'],
    status: ['order status'],
    subStatus: ['order substatus'],
    returnStatus: ['cancelation/return type', 'cancellation/return type'],
    sku: ['seller sku'],
    name: ['product name'],
    variation: ['variation'],
    qty: ['quantity'],
    orderDate: ['created time']
  }
};

/* first-occurrence-wins: cot trung ten khong ghi de cot dau */
export function indexHeader(headerRow) {
  var map = {};
  for (var i = 0; i < headerRow.length; i++) {
    var k = normKey(headerRow[i]);
    if (k && !(k in map)) map[k] = i;
  }
  return map;
}
function pick(map, aliases) {
  for (var i = 0; i < aliases.length; i++) {
    if (aliases[i] in map) return map[aliases[i]];
  }
  return -1;
}

export function detectChannel(map) {
  if ('mã đơn hàng' in map && 'mã vận đơn' in map) return 'SHOPEE';
  if ('order id' in map && 'seller sku' in map) return 'TIKTOK';
  return null;
}

/* ---------- doc 1 workbook ----------
   wb = XLSX.read(buf, {type:'array', cellDates:false, raw:true})
   Moi file chi lay sheet don hang dau tien tim duoc. */
export function parseWorkbook(XLSX, wb, fileName) {
  var out = { fileName: fileName, channel: null, rows: [], notes: [], sheet: null };
  for (var si = 0; si < wb.SheetNames.length; si++) {
    var ws = wb.Sheets[wb.SheetNames[si]];
    if (!ws) continue;
    var grid = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, defval: '', blankrows: false });
    if (!grid.length) continue;

    var headerRow = -1, map = null, channel = null;
    for (var r = 0; r < Math.min(grid.length, 15); r++) {
      var m = indexHeader(grid[r] || []);
      var c = detectChannel(m);
      if (c) { headerRow = r; map = m; channel = c; break; }
    }
    if (headerRow < 0) continue;

    out.channel = channel;
    out.sheet = wb.SheetNames[si];
    var F = FIELDS[channel];
    var col = {};
    Object.keys(F).forEach(function (k) { col[k] = pick(map, F[k]); });

    for (var i = headerRow + 1; i < grid.length; i++) {
      var row = grid[i] || [];
      var get = function (k) { return col[k] >= 0 ? row[col[k]] : ''; };
      var orderId = norm(get('orderId'));
      if (!orderId) continue;
      // dong mo ta cua TikTok (dong 2) va moi dong rac khac
      if (/\s/.test(orderId)) continue;

      var barcode = '';
      if (channel === 'SHOPEE') {
        barcode = norm(get('sku'));
        if (!barcode) barcode = norm(get('skuVariation'));
      } else {
        barcode = norm(get('sku'));
      }

      var full = norm(get('name'));
      var variation = norm(get('variation'));

      out.rows.push({
        channel: channel,
        orderId: orderId,
        tracking: norm(get('tracking')),
        carrier: norm(get('carrier')) || '(không rõ)',
        statusRaw: norm(get('status')),
        subStatus: col.subStatus >= 0 ? norm(get('subStatus')) : '',
        returnStatus: norm(get('returnStatus')),
        orderDate: dateText(get('orderDate')),
        barcode: barcode,
        nameFull: full,
        variation: variation,
        name: displayName(full, variation),
        qty: toInt(get('qty'))
      });
    }
    break; // moi file chi lay sheet don hang dau tien
  }
  if (!out.channel) out.notes.push('Không nhận diện được cột đơn hàng');
  return out;
}

/* Tien ich: doc thang tu ArrayBuffer/Buffer, dung dung option nhu app v4 */
export function parseBuffer(XLSX, buf, fileName, lastModified) {
  var wb = XLSX.read(buf, { type: 'array', cellDates: false, raw: true });
  var pf = parseWorkbook(XLSX, wb, fileName);
  pf.lastModified = lastModified || 0;
  return pf;
}
